import { createSlice } from '@reduxjs/toolkit';

export interface LoginState {
  isLoggedIn: boolean;
  wampConnectError: boolean;
  isLoggedOut: boolean;
  isLoggingOut: boolean;
}

const initialState: LoginState = {
  isLoggedIn: false,
  wampConnectError: false,
  isLoggedOut: false,
  isLoggingOut: false
};

const loginSlice = createSlice({
  name: 'loginState',
  initialState,
  reducers: {
    resetLoginState() {
      return initialState;
    },
    userLoggedIn() {
      return {
        isLoggedIn: true,
        wampConnectError: false,
        isLoggedOut: false,
        isLoggingOut: false
      };
    },
    setWampConnectError(state, action) {
      state.wampConnectError = action.payload;
    },
    openLoginPage(state) {
      return state;
    },
    userLoggingOut() {
      return {
        isLoggedIn: false,
        wampConnectError: false,
        isLoggedOut: false,
        isLoggingOut: true
      };
    },
    userLoggedOut() {
      return {
        isLoggedIn: false,
        wampConnectError: false,
        isLoggedOut: true,
        isLoggingOut: false
      };
    }
  }
});

export const { userLoggedIn, setWampConnectError, openLoginPage, userLoggingOut, userLoggedOut } = loginSlice.actions;
export default loginSlice.reducer;
